import { IGetInfrastructureResponse } from '../repositories/newbuilding-card/v1/get-infrastructure';
import { IFutureRoad } from '../types/map';

export const transformFutureRoads = (responseFutureRoads: IGetInfrastructureResponse['futureRoads']): IFutureRoad[] => {
  if (!responseFutureRoads) {
    return [];
  }

  return responseFutureRoads.map(road => ({
    ...road,
    type: 'futureRoad',
    constructionYearTo: road.constructionYearTo || undefined,
  }));
};
